import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {DEFAULT_PAGE_SIZES} from 'src/hooks/common-data-service/cached-table';

import {PaginationStripe} from '@pb/kit-component-pagination';


import {
    notificationsListStateActions,
    notificationsListStateSelector,
} from './slices/notification-search-criteria.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const NotificationPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(notificationsListStateActions.setPageSize(pageSize));
        dispatch(notificationsListStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(notificationsListStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={state.pagination.pageSize}
            totalCount={totalCount}
            currentPage={state.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={DEFAULT_PAGE_SIZES}
        />
    );
};
